import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { Box, Card } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';

import { formActions } from '../../../../actions';
import { FORM_CONSTANTS, APP_SCENE } from '../../../../constants';
import Loading from '../../../../components/CustomComponents/Loading';

function DanhSachThanhTichProfile(props) {
  const dispatch = useDispatch();
  const loadingForm = useSelector(state => state.formReducer.loading);
	const applicationList = useSelector(state => state.formReducer.applicationList);

	const form = applicationList.find((e) => e.id === props.formId);

	useEffect(() => {
		if (form) dispatch(formActions.setFocusForm(form));
	}, [form]);

	const { GENDER_OPTIONS, ACADEMIC_LEVEL_OPTIONS, POLITICAL_UNION_OPTIONS, FIELD_OPTIONS } = FORM_CONSTANTS;

	// Quá trình học tập, công tác (lưu dạng JSON)
	var processList = [];
	try { processList = JSON.parse(form?.process || '[]') || []; } catch (e) { processList = []; }

	// Thông tin cá nhân (thay cho mục "Tóm tắt thành tích" cũ)
	const infoList = [
		{ label: 'Giới tính', value: GENDER_OPTIONS.find((e) => e.value === form?.profile?.gender)?.title },
		{ label: 'Dân tộc', value: form?.profile?.ethnic },
		{ label: 'Đơn vị học tập, công tác', value: form?.unit },
		{ label: 'Trình độ học vấn', value: ACADEMIC_LEVEL_OPTIONS.find((e) => e.value === form?.academicLevel)?.title },
		{ label: 'Học hàm/chức danh khoa học', value: form?.academicRank },
		{ label: 'Ngoại ngữ', value: form?.languague },
		{ label: 'Đoàn thể chính trị', value: POLITICAL_UNION_OPTIONS.find((e) => e.value === form?.politicalUnion)?.title },
		{ label: 'Lĩnh vực', value: FIELD_OPTIONS[APP_SCENE]?.find((e) => e.value === form?.field)?.title },
		{ label: 'Đơn vị đề cử', value: form?.nominator },
	];

	return (
		<Card style={{ padding: '4px 16px', minHeight: 'calc(100vh - 114px)' }}>
      <Box display='flex' justifyContent='center' padding={1}>
        <img
          // eslint-disable-next-line no-undef
          src={`${process.env.REACT_APP_DOMAIN}${form?.profile?.photoUrl}`}
          style={{ maxWidth: 120, maxHeight: 150, minHeight: 150, objectFit: 'cover' }}
        />
      </Box>
			<Box style={{ textAlign: 'center' }}><b>{form?.profile?.name}</b></Box>
      <Box style={{ textAlign: 'center' }}><b>Ngày sinh: </b>{dayjs(form?.profile?.birth).format('DD/MM/YYYY')}</Box>

      {infoList.map((e) => (
        <Box key={e.label} marginTop={1}>
          <b>{e.label}: </b>
          <span>{e.value || ''}</span>
        </Box>
      ))}

      <Box marginTop={1}><b>Quá trình học tập, công tác:</b></Box>
      {processList.length > 0 ? (
        processList.map((p, idx) => (
          <Box key={idx} marginTop={0.5} style={{ fontSize: 14 }}>
            {`• `}
            {[p?.startAt, p?.finishAt].filter(Boolean).join(' - ')}
            {(p?.startAt || p?.finishAt) ? ': ' : ''}
            {[p?.department, p?.works].filter(Boolean).join(' - ')}
          </Box>
        ))
      ) : (
        <Box style={{ fontSize: 14 }}><i>Chưa có thông tin</i></Box>
      )}

      <Loading open={loadingForm} />
    </Card>
	)
}

export default DanhSachThanhTichProfile;
